import { Section } from '@/components/layout';
import { DisplayTitle, Eyebrow, ScriptLine } from '@/components/typography';
import { BunnyVideo } from '@/components/media';
import { formatDateRangeHero, type TourEvent } from '@/features/events';
import { MigaGira } from '@/pages/shared/MigaGira';
import { HeroReservaCta } from '@/pages/shared/ConversionBlocks';
import styles from './HeroFunes.module.css';

/* =============================================================================
 * S1 · HERO DE /funes
 * -----------------------------------------------------------------------------
 * Funes NO tiene mockup ni sesión de fotos. Desde el 2-nov-2026 el hero lleva a la
 * derecha el vídeo de 23 s que mandó el cliente («no mejor pon este vídeo que dura
 * pocos segundos»), con el traje gris en la apertura y el cierre, en el formato 16:9 de su flyer, y a la izquierda
 * el dato tipado. El MP4 local solo sale si Bunny no ha codificado el suyo.
 *
 * Todo el texto sale de `@/features/events`: ni la fecha, ni el título, ni la
 * promesa están tecleados aquí.
 * ========================================================================== */
export function HeroFunes({ event }: { event: TourEvent }) {
  return (
    <Section width="default" background="surface" labelledBy="funes-hero-titulo" className={styles.hero}>
      <MigaGira event={event} className={styles.miga} />

      <div className={styles.grid}>
        <div>
          <Eyebrow ink="gold">
            {event.city}, {event.country}
          </Eyebrow>
          <DisplayTitle id="funes-hero-titulo" level={1} size="xl">
            {event.titleMain} <span lang="es">{event.titleAccent}</span>
          </DisplayTitle>
          <p className={styles.fecha}>{formatDateRangeHero(event)}</p>
          <p className={styles.lugar}>{event.venue}</p>

          <ul className={styles.promesa} role="list">
            {event.promiseLines.map((linea) => (
              <li key={linea}>{linea}</li>
            ))}
          </ul>

          {/* El claim manuscrito del flyer, tal cual lo escribió el cliente. */}
          {event.scriptClaim === null ? null : <ScriptLine size="lg">{event.scriptClaim}</ScriptLine>}

          <HeroReservaCta event={event} />
        </div>

        <div className={styles.flyerMarco}>
          <BunnyVideo
            videoId="9608fcbe-8d20-4b69-bd8c-bd49fbccf78a"
            description="Vídeo de la convivencia con Azrahel en Alma Sana, Funes, Santa Fe, Argentina, los días 2 y 3 de febrero de 2027"
            poster="/media/funes/convivencia-portada.jpg?v=2026-11-02b"
            fallbackSrc="/media/funes/convivencia-alma-sana.mp4?v=2026-11-02c"
            className={styles.flyerVideo}
          />
        </div>
      </div>
    </Section>
  );
}
